/**
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-08 19:37:58
 * @LastEditTime: 2019-08-09 11:22:58
 * @Version: 1.0
 * @Description: 地图数据转换工具
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */

import AMap from 'AMap'

/*
  根据汉字的地址查询经纬度
  @return LngLat[]
 */
export const queryLngLat = (citys) => {
  return new Promise((resolve, reject) => {
    let geocoder
    if (!geocoder) {
      geocoder = new AMap.Geocoder({
        batch: true
      })
    }
    geocoder.getLocation(citys, (status, result) => {
      if (status === 'complete' && result.geocodes.length) {
        resolve(result.geocodes.filter(item => item !== null).map(item => item.location))
      } else {
        console.error('根据地址查询位置失败')
        reject('')
      }
    })
  })
}

/*
  根据汉字的地址查询经纬度
  @return  [ [number, number] ]
 */
export const queryPoint = (citys) => {
  return new Promise((resolve, reject) => {
    let geocoder
    if (!geocoder) {
      geocoder = new AMap.Geocoder({
        batch: true
      })
    }
    geocoder.getLocation(citys, (status, result) => {
      if (status === 'complete' && result.geocodes.length) {
        const points = result.geocodes.filter(item => item !== null)
          .map(item => item.location)
          .map(item => {
            return [item.lng, item.lat]
          })
        resolve(points)
      } else {
        console.error('根据地址查询位置失败')
        reject('')
      }
    })
  })
}

/*
  将高德地图的Lnglat 或者后台数据的Lnglat转为point
*/
export const changeLngLatToPoint = (lnglat) => {
  if (lnglat && Object.prototype.toString.call(lnglat).indexOf('Array') !== -1) {
    return lnglat.map(item => {
      if (item.lng && item.lat) {
        return [item.lng, item.lat]
      } else if (item.longitude && item.latitude) {
        return [item.longitude, item.latitude]
      }
    })
  } else if (lnglat && Object.prototype.toString.call(lnglat).indexOf('Object') !== -1) {
    if (lnglat.lng && lnglat.lat) {
      return [lnglat.lng, lnglat.lat]
    } else if (lnglat.longitude && lnglat.latitude) {
      return [lnglat.longitude, lnglat.latitude]
    }
  }
}

/*
  根据传入的2个点规划两点的货车路线
*/
export const drawRoute = (start, end) => {
  return new Promise((resolve, reject) => {
    const drivingOption = {
      policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
      ferry: 1 // 是否可以使用轮渡
      // province: '京' // 车牌省份的汉字缩写
    }
    // 构造路线导航类
    const driving = new AMap.Driving(drivingOption)

    // 根据起终点经纬度规划驾车导航路线
    driving.search(start, end, (status, result) => {
      // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
      if (status === 'complete') {
        if (result.routes && result.routes.length) {
          // 绘制第一条路线，也可以按需求绘制其它几条路线
          const path = parseRouteToPath(result.routes[0])
          resolve(path)
        }
      } else {
        reject(result)
        console.error('获取驾车数据失败：' + result)
      }
    })
  })
}

function parseRouteToPath(route) {
  const path = []

  for (let i = 0, l = route.steps.length; i < l; i++) {
    const step = route.steps[i]

    for (let j = 0, n = step.path.length; j < n; j++) {
      path.push(step.path[j])
    }
  }
  return path
}
